import { SecondaryButton } from '@pulse-web-ui/button-v2';
import { media, styled, typography } from '@pulse-web-ui/theme';

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
`;

export const Title = styled.h2`
  ${typography.medium20};
  width: 100%;
  margin: 0;
  color: ${({ theme }) => theme.colors.text.primary};

  ${media.desktop} {
    ${typography.medium24};
  }
`;

export const Choices = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export const ChoiceButton = styled(SecondaryButton)`
  width: 100%;
  height: 64px;
  padding: 0 32px;
  justify-content: space-between;

  > span:first-child {
    width: 100%;
    justify-content: space-between;
  }

  ${media.desktop} {
    width: 100%;
  }
`;
